const CLOUDINARY_VERSIONED_PATH = /^(https:\/\/res\.cloudinary\.com\/[^/]+\/(?:image\/upload\/)?)(v\d+\/)/;

// Asks Cloudinary for a resized copy (e.g. "c_fill,w_320,h_320"); any other URL is returned as is.
export default function cloudinarySized(url, transformation) {
  return url.replace(CLOUDINARY_VERSIONED_PATH, `$1${transformation},q_auto,f_auto/$2`);
}

// The original file served as a download ("fl_attachment"); any other URL is returned as is.
export function cloudinaryAttachment(url) {
  return url.replace(CLOUDINARY_VERSIONED_PATH, "$1fl_attachment/$2");
}
